export default __webpack_public_path__ + "static/media/BEFIT.778e79b3.jpg";